// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__8iuqU","back":"layout_back__t3xMY"};